/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Pattern_MamInputs */

const vi_tea_purchase_pattern_mam = /** @type {(inputs: Tea_Purchase_Pattern_MamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mầm`)
};

/**

* @param {Tea_Purchase_Pattern_MamInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_pattern_mam = /** @type {((inputs?: Tea_Purchase_Pattern_MamInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Pattern_MamInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_pattern_mam(inputs)
});